import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const editSpinCampaignRoutes = {
  name: 'spin-campaign-edit',
  path: 'spin-campaign/:id/edit',
  component: () => import('./EditSpinCampaign.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
